/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SpendBucket, SpendBucket$inboundSchema } from "./spendbucket.js";

export const Id = {
  AgentSessionStorage: "agent_session_storage",
  RiskContentScans: "risk_content_scans",
  McpEgress: "mcp_egress",
} as const;
export type Id = ClosedEnum<typeof Id>;

export const SpendProductUnit = {
  Stokens: "stokens",
  Bytes: "bytes",
} as const;
export type SpendProductUnit = ClosedEnum<typeof SpendProductUnit>;

export type SpendProduct = {
  /**
   * Dense UTC daily product buckets, including in-progress and future days
   */
  buckets: Array<SpendBucket>;
  /**
   * Exact estimated product cost at current PAYG list prices
   */
  costUsd: string;
  id: Id;
  label: string;
  /**
   * Exact integer ordinary usage quantity as a decimal string
   */
  quantity: string;
  /**
   * Exact integer quantity to which rate_usd applies
   */
  rateQuantity: string;
  /**
   * Exact current PAYG USD list price
   */
  rateUsd: string;
  unit: SpendProductUnit;
};

/** @internal */
export const Id$inboundSchema: z.ZodMiniEnum<typeof Id> = z.enum(Id);

/** @internal */
export const SpendProductUnit$inboundSchema: z.ZodMiniEnum<
  typeof SpendProductUnit
> = z.enum(SpendProductUnit);

/** @internal */
export const SpendProduct$inboundSchema: z.ZodMiniType<SpendProduct, unknown> =
  z.pipe(
    z.object({
      buckets: z.array(SpendBucket$inboundSchema),
      cost_usd: z.string(),
      id: Id$inboundSchema,
      label: z.string(),
      quantity: z.string(),
      rate_quantity: z.string(),
      rate_usd: z.string(),
      unit: SpendProductUnit$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "cost_usd": "costUsd",
        "rate_quantity": "rateQuantity",
        "rate_usd": "rateUsd",
      });
    }),
  );

export function spendProductFromJSON(
  jsonString: string,
): SafeParseResult<SpendProduct, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendProduct$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendProduct' from JSON`,
  );
}
